export default __webpack_public_path__ + "static/media/data-science.a73a6050.svg";